import { apiFetch } from "../utils/apiFetch"

export function createSeniority(data: any) {
  return apiFetch("/api/seniorities", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function updateSeniority(id: string, data: any) {
  return apiFetch(`/api/seniorities/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deleteSeniority(id: string) {
  return apiFetch(`/api/seniorities/${id}`, { method: "DELETE" })
}

export function getSeniorities() {
  return apiFetch("/api/seniorities")
}
